import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import {
    TgButtons2Module,
    TgFormsModule,
    TgValidationModule
} from '@trademe/tangram';
import { PhotoValidationModule } from '../services/validation/photo-validation.module';
import { PhotoPickerComponent } from './photo-picker.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        TgFormsModule,
        TgValidationModule,
        PhotoValidationModule,
        TgButtons2Module
    ],
    declarations: [PhotoPickerComponent],
    providers: [NgForm],
    exports: [PhotoPickerComponent]
})
export class PhotoPickerModule {}
